// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueFuse from 'vue-fuse'
Vue.use(VueFuse)
import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

//fontAwesome 4
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

//v-calendar
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
// Use v-calendar, v-date-picker & v-popover components
Vue.use(VCalendar)

//vue2-animate //https://github.com/asika32764/vue2-animate 
import 'vue2-animate/dist/vue2-animate.min.css'

import firebase from 'firebase'


import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

Vue.prototype.$appVer = '1.2.5'


router.beforeEach((to, from, next) => {
  //console.log(to)
  window.scrollTo(0, 0)

  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)

  if (requiresAuth) {
    if(!currentUser) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      //check to see if user is admin
      if(requiresAdmin) {
        console.log(`This route requires Admin`)
        console.log(store.state.user)
        if(store.state.user){
          console.log(`This user is Admin`)
          next()
        } else {
          console.log(`This user is NOT Admin... redirect to login`)
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        } 
      } else {
        next()
      }

    }
  } else {
    next ()
  }


})

Vue.config.productionTip = false

firebase.auth().onAuthStateChanged(user => {
  console.log(`Firebase OnAuthStateChange fired!`)
  if(!user) {
    console.log(`No user... routing to login`)
    router.replace('/home')
  }
})

let app = new Vue ({
  el: '#app',
  router,
  store,
  template: '<App/>',
  created () {

  },
  data () {
    return {
      appName: 'whtBrd',
      appVer: this.$appVer
    }
  },
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js